// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3hTl3","label":"CategoryService_label__LMBXr","location":"CategoryService_location__2hRBt"};